import styled from 'styled-components';

import { Allergens } from '../allergens';

export const StyledAllergens = styled(Allergens)`
  margin: 0;
  font-size: 1rem;
  p + p {
    margin-block-start: 10px;
  }
`;
